<template>
  <v-card :flat="flat" :color="transparent ? 'transparent' : ''" :dark="dark">
    <h5 v-text="$t('text.your company')" />
    
    <br>
    {{ $t('text.org_no') }}: {{ customer.OrganisationNumber }} 
    <br>
    {{$t('text.name')}}: {{ customer.Name}} 
    <br>


    <template v-if="parentCustomer">
      <br>
      {{ $t('text.main_office') }}: {{ parentCustomer.Name }}
      <br>
    </template>

    <template v-if="customerGoup">
      <br>
      {{ $t('text.part_of_group') }}:
      <v-list-item class="px-0" style="max-width: 300px;">
        <v-list-item-icon class="my-auto mr-3">
          <CustomerGroupImage :size="40" :relativePath="customerGoup && customerGoup.Image">
          </CustomerGroupImage>
        </v-list-item-icon>
        <v-list-item-content class="py-0">
          <v-list-item-title>
            {{ customerGoup.Name }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </template>

  </v-card>
</template>


<script>
import CustomerGroupImage from "@/components/Cards/CustomerGroupImage.vue";

export default {
  name: "CompanyContactCard",
  props: {
    dark: Boolean,
    transparent: Boolean,
    flat: Boolean,
  },
  components: {
    CustomerGroupImage,
  },

  data() {
    return {};
  },

  methods: {},

  computed: {
    userInfo() {
      if (this.$store.state.userInfo) return this.$store.state.userInfo;
      return { Customer: {}, Provider: {} };
    },

    customer() {
      return this.userInfo && this.userInfo.Customer;
    },

    customerGoup() {
      return this.customer && this.customer.CustomerGroup;
    },

    parentCustomer() {
      return this.customer && this.customer.Parent;
    },
  },

  watch: {},
};
</script>


<style lang='scss' scoped>
</style>